import { useAuth } from 'react-oidc-context';
import { Navigate, Outlet } from 'react-router-dom';

import { useUserStore } from '@/stores/user.store';
import { getWorkspaceRoute } from '@/utils/routes';

function GuestRoute() {
  const { isLoading, isAuthenticated } = useAuth();
  const { org } = useUserStore();

  if (isAuthenticated) {
    const redirect = org ? getWorkspaceRoute('/dashboard') : '/';
    return <Navigate to={redirect} replace />;
  }

  if (isLoading) return <></>;

  return <Outlet />;
}

export default GuestRoute;
